import { IconBulb, IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, Outlet } from 'react-router-dom';

import { AccessDenied } from 'src/Components/AccessDenied';
import { SplitButton } from 'src/Components/Inputs/SplitButton';
import { PageHeader } from 'src/Components/Navigation/PageHeader';
import { useCanCreate, useCanRead } from 'src/Hooks/Shared/useHasPermission';

import { ProjectKanban } from '../ProjectKanban';

import styles from './ProjectsMainPage.module.scss';

const ProjectsMainPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { assetId } = useParams<{ assetId: string }>();

  // Permission checks
  const { hasPermission: canRead, ownerName } = useCanRead('project');
  const { hasPermission: canCreate } = useCanCreate('project');

  // Show access denied if user doesn't have read permission
  if (!canRead) {
    return <AccessDenied ownerName={ownerName} />;
  }

  return (
    <div className={styles.container}>
      <PageHeader
        label={t('projects.title', 'Idées & Projets')}
        rightElement={
          canCreate && (
            <SplitButton
              label={t('projects.new', 'Nouveau projet')}
              leftSection={<IconPlus size={14} />}
              onClick={() => navigate(`/asset/${assetId}/project-and-works/new`)}
              menuItems={[
                {
                  label: t('ideas.new', 'Créer une idée'),
                  icon: <IconBulb size={16} />,
                  onClick: () => navigate(`/asset/${assetId}/project-and-works/new-idea`),
                },
              ]}
            />
          )
        }
      />
      <div className={styles.spacer} />
      <ProjectKanban assetId={assetId!} />
      <Outlet />
    </div>
  );
};

export default ProjectsMainPage;
